module.exports = __webpack_public_path__ + "img/10.8ce62eaf.png";